// extracted by mini-css-extract-plugin
export default {"root":"DomainBundle-root_Kzndq"};